var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("ModalFullScreen", {
    attrs: { size: "md", modalId: "modal-lv3" },
    on: { close: _vm.closeModal },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _c("span", { staticClass: "font-semibold text-base mb-5" }, [
              _vm._v(
                _vm._s(_vm.updatedExperience ? "Edit" : "Add") + " Experience"
              ),
            ]),
            _c(
              "span",
              {
                staticClass:
                  "cursor-pointer flex items-center justify-center absolute top-4 right-5",
                on: {
                  click: _vm.closeModal,
                  mouseover: function ($event) {
                    _vm.isHovered = true
                  },
                  mouseout: function ($event) {
                    _vm.isHovered = false
                  },
                },
              },
              [
                !_vm.isHovered
                  ? _c("CrossIcon", { staticClass: "h-3.5 w-3.5" })
                  : _vm._e(),
                _vm.isHovered
                  ? _c("CrossIconHover", { staticClass: "close-icon" })
                  : _vm._e(),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "content",
        fn: function () {
          return [
            _c("ModalContent", { staticClass: "relative" }, [
              _c(
                "div",
                { staticClass: "mt-5" },
                [
                  _c("ExperienceForm", {
                    attrs: { experience: _vm.experiences },
                    on: {
                      updated: _vm.editExperience,
                      added: _vm.addExperience,
                      close: _vm.closeModal,
                    },
                  }),
                ],
                1
              ),
            ]),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }